import React from "react";
import { Quote } from "lucide-react";

const quotes = [
  {
    name: "Marcus T.",
    role: "Uber + DoorDash · Atlanta",
    initial: "M",
    color: "#00FF88",
    text:
      "Slow Tuesday hit and I needed gas before my Wednesday rush. GigAfloat sent me an $80 Float in 12 seconds. Repaid Friday. Felt seen, not exploited.",
  },
  {
    name: "Priya S.",
    role: "Lyft + Instacart · NYC",
    initial: "P",
    color: "#14F195",
    text:
      "Finally an app that gets that my income isn't 'irregular'. It's just real. Watching my actual numbers in one place changed how I plan my week.",
  },
  {
    name: "Devon C.",
    role: "Instacart + Spark · Austin",
    initial: "D",
    color: "#7BE495",
    text:
      "The tax vault alone is worth it. I never have to panic in April again. It's finally like my income has a home.",
  },
];

const Testimonials = () => (
  <section className="py-24 md:py-32 relative" data-testid="testimonials">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="max-w-2xl mb-14">
        <div className="font-mono-c text-[10px] uppercase tracking-[0.25em] text-[#00FF88] mb-4">
          // The movement
        </div>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.02]">
          Built around gig workers,
          <br />
          <span className="text-white/40">not credit scores.</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {quotes.map((q, i) => (
          <div
            key={i}
            className="glass rounded-3xl p-7 lg:p-8 flex flex-col hover:-translate-y-1 transition-transform duration-500"
            data-testid={`testimonial-${i}`}
          >
            <Quote className="w-7 h-7 text-[#00FF88] mb-5" />
            <p className="text-white/85 leading-relaxed flex-1">{q.text}</p>
            <div className="mt-6 flex items-center gap-3 pt-5 border-t border-white/5">
              <div
                className="w-10 h-10 rounded-full grid place-items-center font-display font-extrabold text-black"
                style={{ background: q.color }}
              >
                {q.initial}
              </div>
              <div>
                <div className="font-semibold text-white text-sm">{q.name}</div>
                <div className="text-xs text-white/50 font-mono-c">{q.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
